import React, { useEffect, useState } from "react";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import {
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Typography,
  Grid,
  Stack,
  Box,
  Button,
  Tooltip,
} from "@mui/material";
import MaterialButton from "../components/MaterialButton";
import BASEURL from "../pages/Utils/Baseurl";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ConfirmationDialog from "../components/Dialog/ConfirmationDialog";
import CloseIcon from "@mui/icons-material/Close"; // Import CloseIcon
 
import Swal from "sweetalert2";
import { Check, ContentCopy } from "@mui/icons-material";
function ApprovalScreen() {
  const [employeeData, setemployeeData] = useState([]);
  const [display, setdisplay] = useState(
    sessionStorage.getItem("canapprovestaffrequest") || false
  );
  const [Staffdata, SetStaffdata] = useState([]);
  const navigate = useNavigate();
  const [Id, setId] = useState("");
  const [copied, setCopied] = useState(false);
  const [copiedJd, setCopiedJd] = useState(false);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      // setPageState((prevState) => ({
      //   ...prevState,
      //   loading: false,
      //   state: "default",
      // }));
    }
  }, []);

  const getInitData = async (id) => {
    const query = `query GetStaffRequestById($id: ID!) {
  staffRequest(id: $id) {
    jobid
    requestDate
    teamName
    teamLeadName
    projectName
    startDate
    role
    salaryLpa
    experience
    employmentType
    approvalStatus
    jobStatus
    keySkills
    priority
    noOfPositions
    preference
    interviewPannel
    noOfRounds
    responsiblePerson
    positionStatus
    jd
    justificationForRequest
  }
} `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data.staffRequest;
      if (result?.approvalStatus != null) {        
         setdisplay(false)
      }
    

      SetStaffdata(result);
      //  let teamname = department.filter((val)=> val.id === result.teamName)
      //  let teamlead = employeenames.filter((val)=> val.id === result.teamLeadName)

      //  setstaffrequest({
      //     ...staffrequest,
      //     jobid: {value :result.jobid , label: result.jobid },
      //     requestdate: result.requestDate,
      //     teamname : {value: teamname[0]?.id ,label : teamname[0]?.departmentName},
      //     teamleadname : {value:teamlead[0]?.id,label:teamlead[0]?.firstName},
      //     projectname: result.projectName,
      //     startdate: result.startDate,
      //     role: {value:result.role,label:result.role},
      //     salarylpa : result.salaryLpa,
      //     experience: result.experience,
      //     employmentType: {value:result.employmentType,label:result.employmentType},
      //     priority: {value:result.priority,label:result.priority},
      //     keySkills: result.keySkills,
      //     Noofposition: result.noOfPositions,
      //     Noofrounds : result.noOfRounds,
      //     jd: result.jd,
      //     justificationrequest : result.justificationForRequest
      //  })
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };

  const handleCopySkills = async () => {
    if (!Staffdata?.keySkills) return;

    try {
      await navigator.clipboard.writeText(Staffdata.keySkills);

      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 1200);
    } catch (error) {
      console.error("Failed to copy key skills:", error);
    }
  };

  const handleCopyJd = async () => {
    if (!Staffdata?.jd) return;

    try {
      await navigator.clipboard.writeText(Staffdata.jd);

      setCopiedJd(true);

      setTimeout(() => {
        setCopiedJd(false);
      }, 1200);
    } catch (error) {
      console.error("Failed to copy job description:", error);
    }
  };

  const handleclose = () => {
    navigate("/staff-request");
  };

  const handleAdd = (Status) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: `Are you sure you want to ${
        Status == "Recruitment in progress" ? "approve" : "reject"
      } the request?`,
      message: `Are you sure you want to ${
        Status == "Recruitment in progress" ? "approve" : "reject"
      } the request?`,
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handleSubmit(Status);
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleSubmit = async (Status) => {
    const query = `mutation UpdateStaffRequest($id: ID!, $input: StaffRequestInput!) {
  updateStaffRequest(id: $id, input: $input) {
    staffRequest {
      approvalStatus
    }
  }
}`;

    let alldata = {
      approvalStatus: Status,
    };

    try {
      const response = await axios.post(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        query,
        variables: {
          id: Id,
          input: alldata,
        },
      });

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      let finaldata =
        response.data.data.updateStaffRequest?.staffRequest?.approvalStatus;

      if (finaldata === "Recruitment in progress") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Staff Request Approved Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/staff-request");
      } else if (finaldata === "Rejected") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Staff Request Rejected Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/staff-request");
      }
    } catch (error) {
      console.log("Error:", error.message);
    }
  };

  return (
    <DashboardLayout>
      <ConfirmationDialog
        open={confirmationDialog.open}
        title={confirmationDialog.title}
        message={confirmationDialog.message}
        showCancel={confirmationDialog.showCancel}
        showConfirm={confirmationDialog.showConfirm}
        customSection={confirmationDialog.customSection}
        onConfirm={confirmationDialog.onConfirm}
        onCancel={confirmationDialog.onCancel}
      />
      <Card
        sx={{
          padding: 2,
          boxShadow: 3,
          borderRadius: 2,
          backgroundColor: "#fff",
        }}
      >
        {/* Card Header */}
        <CardHeader
          title={
            <Typography
              style={{ fontSize: "23px" }}
              variant="h6"
              fontWeight="bold"
              textAlign="center"
            >
              Staff Request Details
            </Typography>
          }
          action={
            <IconButton aria-label="close" onClick={handleclose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          }
          sx={{ paddingBottom: 0 }}
        />

        <CardContent>
          {/* Section - Basic Details */}
          <Box
            sx={{
              backgroundColor: "#f7f9fc",
              padding: "8px",
              borderRadius: 1,
              mb: 2,
            }}
          >
            <Typography variant="body1" fontWeight={600} color="#3F51B5d4">
              Basic Details
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {[
              { label: "Job ID", value: Staffdata?.jobid },
              { label: "Requested Date", value: Staffdata?.requestDate },
              { label: "Team Lead Name", value: Staffdata?.teamLeadName },
              { label: "Project Name", value: Staffdata?.projectName },
              { label: "Team Name", value: Staffdata?.teamName },
              { label: "Start Date", value: Staffdata?.startDate },
            ].map((item, index) => (
              <Grid item xs={12} sm={4} key={index}>
                <Typography variant="body2">
                  <strong style={{ color: "#2c3e50" }}>{item.label}:</strong>{" "}
                  <span style={{ color: "#616a6b" }}>{item.value}</span>
                </Typography>
              </Grid>
            ))}
          </Grid>

          {/* Section - Position Details */}
          <Box
            sx={{
              backgroundColor: "#f7f9fc",
              padding: "8px",
              borderRadius: 1,
              mt: 3,
              mb: 2,
            }}
          >
            <Typography variant="body1" fontWeight={600} color="#3F51B5d4">
              Position Details
            </Typography>
          </Box>

          <Grid container spacing={2}>
            {[
              { label: "Role", value: Staffdata?.role },
              { label: "Employee Type", value: Staffdata?.employmentType },
              { label: "No of Positions", value: Staffdata?.noOfPositions },
              { label: "Salary LPA", value: Staffdata?.salaryLpa },
              { label: "Priority", value: Staffdata?.priority },
              { label: "No of Rounds", value: Staffdata?.noOfRounds },
              { label: "Experience", value: Staffdata?.experience },
            ].map((item, index) => (
              <Grid item xs={12} sm={4} key={index}>
                <Typography variant="body2">
                  <strong style={{ color: "#2c3e50" }}>{item.label}:</strong>{" "}
                  <span style={{ color: "#616a6b" }}>{item.value || "-"}</span>
                </Typography>
              </Grid>
            ))}

            {/* Key Skills */}
            <Grid item xs={12}>
              <Box
                display="flex"
                alignItems="center"
                gap={0.5}
                mb={1}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: "#2c3e50",
                    fontWeight: 700,
                  }}
                >
                  Key Skills
                </Typography>

                <Tooltip title={copied ? "Copied!" : "Copy Key Skills"} disableInteractive>
                  <IconButton
                    size="small"
                    onClick={handleCopySkills}
                    disabled={!Staffdata?.keySkills}
                    sx={{
                      p: 0.4,
                      color: copied ? "#2e7d32" : "#616a6b",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        color: copied ? "#2e7d32" : "#1976d2",
                        backgroundColor: copied
                          ? "rgba(46, 125, 50, 0.08)"
                          : "rgba(25, 118, 210, 0.08)",
                      },
                    }}
                  >
                    {copied ? (
                      <Check fontSize="small" />
                    ) : (
                      <ContentCopy sx={{fontSize: "0.6rem"}} />
                    )}
                  </IconButton>
                </Tooltip>
              </Box>

              <Box
                sx={{
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #e5e7e9",
                  borderRadius: 2,
                  p: 2,
                  minHeight: 80,
                  maxHeight: 120,
                  overflowY: "auto",
                  whiteSpace: "pre-line",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: "#616a6b",
                    lineHeight: 1.8,
                    fontSize: "14px",
                  }}
                >
                  {Staffdata?.keySkills || "No key skills available."}
                </Typography>
              </Box>
            </Grid>

            {/* JD Section */}
            <Grid item xs={12}>
              <Box
                display="flex"
                alignItems="center"
                gap={0.5}
                mb={1}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: "#2c3e50",
                    fontWeight: 700,
                  }}
                >
                  Job Description
                </Typography>

                <Tooltip title={copiedJd ? "Copied!" : "Copy Job Description"} disableInteractive>
                  <IconButton
                    size="small"
                    onClick={handleCopyJd}
                    disabled={!Staffdata?.jd}
                    sx={{
                      p: 0.4,
                      color: copiedJd ? "#2e7d32" : "#616a6b",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        color: copiedJd ? "#2e7d32" : "#1976d2",
                        backgroundColor: copiedJd
                          ? "rgba(46, 125, 50, 0.08)"
                          : "rgba(25, 118, 210, 0.08)",
                      },
                    }}
                  >
                    {copiedJd ? (
                      <Check fontSize="small" />
                    ) : (
                      <ContentCopy sx={{fontSize: "0.6rem"}} />
                    )}
                  </IconButton>
                </Tooltip>
              </Box>

              <Box
                sx={{
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #e5e7e9",
                  borderRadius: 2,
                  p: 2,
                  maxHeight: 400,
                  overflowY: "auto",
                  whiteSpace: "pre-line",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: "#616a6b",
                    lineHeight: 1.8,
                    fontSize: "14px",
                  }}
                >
                  {Staffdata?.jd || "No job description available."}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* Action Buttons */}
          {display && (
            <Grid container spacing={2} justifyContent="center" sx={{ mt: 3 }}>
              <Grid item>
                <MaterialButton
                  variant="gradient"
                  color="error"
                  size="medium"
                  onClick={() => handleAdd("Rejected")}
                >
                  Reject
                </MaterialButton>
              </Grid>
              <Grid item>
                <MaterialButton
                  variant="gradient"
                  color="success"
                  size="medium"
                  onClick={() => handleAdd("Recruitment in progress")}
                >
                  Approve
                </MaterialButton>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
 
export default ApprovalScreen;